import React, { Fragment, useState, useEffect } from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";


import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Alert } from '@mui/material';

import { setDataAction } from 'redux/actions/getFormActions';

const useStyles = makeStyles((theme) => ({
    select: {
        '& .MuiSvgIcon-root': {
            color: theme.palette.primary.main
        },
        '&:hover': {
            backgroundColor: '#e4dfdf6b'
        }
    },
    icon: {
        fill: theme.palette.primary,
    },
}));

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;
  
    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        isNumericString
        prefix="$"
        decimalScale={3}
      />
    );
  });
  
  NumberFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

const Form3 = (props) => {
    const {actions, formData, handleNext, handleBack } = props;
    const [vacantCheck, setVacantCheck] = useState('No');
    const [evictionCheck, setEvictionCheck] = useState('No');
    const [keyCheck, setKeyCheck] = useState('No');
    const [rentDate, setRentDate] = useState(null);
    const [evictionDate, setEvictionDate] = useState(null);
    const [lateFiling, setLateFiling] = useState(false);
    const [lateFilingExplanation, setLateFilingExplanation] = useState('');

    const today = new Date();
    const maxClaimDate = `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`;

    let disable = true;

    useEffect(() => {
        setVacantCheck(formData.data.vacantCheck || 'No');
        setEvictionCheck(formData.data.evictionCheck || 'No');
        setKeyCheck(formData.data.keyCheck || 'No');
        setRentDate(formData.data.rentDate || null);
        setEvictionDate(formData.data.evictionDate || null);
        setLateFilingExplanation(formData.data.lateFilingExplanation);
        setLateFiling(formData.data.lateFiling);
    }, [formData])

    const handleRentDate = (e) => {
      if(e && e['$d'] != 'Invalid Date') {
        const value = new Date(e['$d']).toISOString().slice(0, 10);
        const date1 = new Date(value);
        const date2 = new Date();
        if(((date2 - date1)/(1000*60*60*24)) >= 120) {
          setLateFiling(true);
        } else {
          setLateFiling(false);
        }
        setRentDate(value);
      }
    };

    const handleKeyCheck = (event) => {
        setKeyCheck(event.target.value);
      };

    const handleVacantCheck = (event) => {
      if(event.target.value === 'No') {
        setKeyCheck('No');
      }
        setVacantCheck(event.target.value)
    }

    const handleEvictionCheck = (event) => {
      if(event.target.value === 'No') {
        setEvictionDate(null);
      }
        setEvictionCheck(event.target.value);
    }

    const handleEvictionDate = (e) => {
      if(e && e['$d'] != 'Invalid Date') {
        const value = new Date(e['$d']).toISOString().slice(0, 10);
        setEvictionDate(value);
      }
    }

    const handleNextButton = () => {
        actions.setDataAction({
            ...formData.data,
            vacantCheck: vacantCheck,
            evictionCheck: evictionCheck,
            keyCheck: keyCheck,
            rentDate: rentDate,
            evictionDate: evictionDate,
            lateFiling: lateFiling,
            lateFilingExplanation: lateFilingExplanation

        })
        handleNext();
    }

    const now = new Date().toISOString();
    if(rentDate && rentDate < now && evictionCheck === 'No') {
      disable = false;
    } else if (rentDate && rentDate < now && evictionCheck === 'Yes' && evictionDate) {
      disable = false;
    } 

  return (
    <Fragment>
       <Grid container justifyContent='space-around' alignItems='center' sx={{mt:5}}>
          <Grid item md={5} xs={5}>
            <Typography color="primary" variant="h6" align='left' sx={{pt:2}}>     
              Date of Loss
              <Tooltip 
                title={
                <Typography variant='body1'>
                  Date of Loss’ equals Missed Rents, Damages, Re-rent Shortfall and Related Expenses up to the Total Coverage Limit  (FE only). Please upload any late notice support documentation under ‘Other Documents’ on page (5)
                </Typography>
                } 
                placement="right-start" 
                arrow
                sx={{ml: 1}}
              >
                  <HelpIcon fontSize='small'  color="primary" />
              </Tooltip>
            </Typography>
          </Grid>
          <Grid item md={4} xs={5}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  variant="standard"
                  label="Date of Loss"
                  inputFormat="DD/MM/YYYY"
                  minDate="01/01/2018"
                  maxDate={maxClaimDate}
                  value={rentDate}
                  onChange={(e) => handleRentDate(e)}
                  renderInput={(params) => <TextField variant="standard" {...params} sx={{svg: {color: '#702572'}}} />}
                />
              </LocalizationProvider>
          </Grid>
        </Grid>
        {lateFiling &&
          <>
            <Typography color="primary" sx={{mt:3}}>The date of loss you have entered is greater than 120 days.  Please provide an explanation for the reason for late filing</Typography>
            <Grid container justifyContent="space-around" alignItems="center">
              <TextField
                fullWidth
                multiline
                rows={4}
                value={lateFilingExplanation}
                onChange={e => setLateFilingExplanation(e.target.value)}
                variant='standard'
                InputProps={{ sx: { p:0 }}}
              />
            </Grid>
            <Alert  severity="info">
              Please upload any late notice support documentation under ‘Other Documents’ on page (5)
            </Alert>
          </>
        }
        <Grid container justifyContent='space-around' alignItems='center' sx={{ mt: 3}}>
            <Grid item md={7} xs={6}>
              <Typography color="primary" variant="h6" align='left'>     
                Has the tenant left the unit?
              </Typography>
            </Grid>
            <Grid item md={4} xs={5}>
              <FormControl disabled={formData.data.claimType === 'No Show'}>
                  <RadioGroup
                    row
                    value={vacantCheck}
                    onChange={handleVacantCheck}
                  >
                      <FormControlLabel value='Yes' control={<Radio />} label="Yes" />
                      <FormControlLabel value='No' control={<Radio />} label="No" />
                  </RadioGroup>
              </FormControl>
            </Grid>
        </Grid>
        {vacantCheck === 'Yes' &&
          <Grid container justifyContent='space-around' alignItems='center' sx={{ mt: 3}}>
              <Grid item md={7} xs={6}>
                <Typography color="primary" variant="h6" align='left'>     
                  Have the keys been returned?
                </Typography>
              </Grid>
              <Grid item md={4} xs={5}>
                <FormControl>
                  <RadioGroup
                    row
                    value={keyCheck}
                    onChange={handleKeyCheck}
                  >
                      <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                      <FormControlLabel value="No" control={<Radio />} label="No" />
                  </RadioGroup>
                </FormControl>
              </Grid>
          </Grid>
        }
        <Grid container justifyContent='space-around' alignItems='center' sx={{ mt: 3}}>
            <Grid item md={7} xs={6}>
              <Typography color="primary" variant="h6" align='left'>     
                  Have you filed for eviction?
              </Typography>
            </Grid>
            <Grid item md={4} xs={5}>
              <FormControl disabled={formData.data.claimType === 'No Show'}>
                  <RadioGroup
                  row
                  value={evictionCheck}
                  onChange={handleEvictionCheck}
                  >
                      <FormControlLabel value='Yes' control={<Radio />} label="Yes" />
                      <FormControlLabel value='No' control={<Radio />} label="No" />
                  </RadioGroup>
              </FormControl>
            </Grid>
        </Grid>
        {evictionCheck === 'Yes' &&
          <Grid container justifyContent='space-around' alignItems='center' sx={{ mt: 3}}>
            <Grid item md={7} xs={6}>
              <Typography color="primary" variant="h6" align='left'>     
                Date you filed for eviction
              </Typography>
            </Grid>
            <Grid item md={4} xs={5}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      variant="standard"
                      label="Eviction Filing Date"
                      inputFormat="DD/MM/YYYY"
                      minDate="01/01/2018"
                      value={evictionDate}
                      onChange={(e) => handleEvictionDate(e)}
                      renderInput={(params) => <TextField variant="standard" {...params} sx={{svg: {color: '#702572'}}} />}
                    />
                  </LocalizationProvider>
            </Grid>
          </Grid>
        }
        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', py: 2, mt: 2 }}>
                <Button
                onClick={handleBack}
                sx={{ mr: 1 }}
                variant="contained"
                >
                Back
                </Button>

            <Button onClick={handleNextButton} variant="contained" disabled={disable} >
                <Typography variant='body1' >
                    Next
                </Typography>
            </Button>
        </Box>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
    return {
        formData: state.formData
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      actions: bindActionCreators({ 
            setDataAction, 
        }, dispatch),
    };
  };
  
export default connect(mapStateToProps, mapDispatchToProps)(Form3);
